import { Injectable } from '@angular/core';
import DataSource from 'devextreme/data/data_source';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { getComponentViewByInstance } from '@angular/core/src/render3/context_discovery';
import { BehaviorSubject } from 'rxjs';
import { DataAccessService } from '../../shared/services/dataaccess.service';
export class passingcertificate{
  PassingCertificateApplicationID: number;
  StudentID: number;
  ApplicationNO: string;
  RequestDate: string;
  ExamInstanceID: number;
  CoursePartID: number;
  BranchID: number;
  CollegeID: number;
  CentreID: number;
  PassingCertificateApplicationFees: number;
  PaymentType:string;
  CreatedLoginID: number;
  UpdatedLoginID: number;
  SeatNoChar:string;
  ClassID:number;
}
@Injectable({
  providedIn: 'root'
})
export class PassingcerificateService {
  constructor(
    private dataService: DataAccessService) {
  }

 
 
  public save(data) {debugger
    this.dataService.setControllerName = '/PortalStudentPassingCertificateApplication/';
    this.dataService.setMethodName = 'PostInsertPortalStudentPassingCertificateApplicationNEW'; 
    return this.dataService.add<passingcertificate[]>(data) 
  }
  public GetDataforPassingCertificateList(StudentID,ExamInstanceID,AcademicInstanceID,CoursePartID) {debugger
    this.dataService.setControllerName = '/PortalStudentPassingCertificateApplication/';
    this.dataService.setMethodName = 'GetDataforPassingCertificateList?StudentID='+ StudentID+'&ExamInstanceID='+ExamInstanceID+'&AcademicInstanceID='+AcademicInstanceID+'&CoursePartID='+CoursePartID; // setting method name from API controller.
    return this.dataService.getAll<passingcertificate[]>()
  }

  public CheckPassingCertifcateStatusForNewRequest(StudentID,ExamInstanceID,AcademicInstanceID,CoursePartID) {debugger
    this.dataService.setControllerName = '/PortalStudentPassingCertificateApplication/';
    this.dataService.setMethodName = 'CheckPassingCertifcateStatusForNewRequest?StudentID='+ StudentID+'&ExamInstanceID='+ExamInstanceID+'&AcademicInstanceID='+AcademicInstanceID+'&CoursePartID='+CoursePartID; // setting method name from API controller.
    return this.dataService.getAll<passingcertificate[]>()
  }

  public GetUpdatePaymentStatusForPassingCertificate(merchantTxnNo,ExamInstanceID,ApplicationNO,StudentID) {debugger
    this.dataService.setControllerName = '/Payment/';
    this.dataService.setMethodName = 'GetUpdatePaymentStatusForPassingCertificate?merchantTxnNo='+ merchantTxnNo + '&ExamInstanceID='+ExamInstanceID+'&ApplicationNO='+ApplicationNO +'&StudentID='+StudentID; // setting method name from API controller.
    return this.dataService.getAll<passingcertificate[]>()
  }
  public CancelPassingCertificate(RequestID,StudentID,AcademicInstanceID,ResultQueryCode) {
    this.dataService.setControllerName = '/PortalStudentPassingCertificateApplication/';
    this.dataService.setMethodName = 'CancelPassingCertificate?RequestID='+RequestID+'&StudentID='+StudentID+'&AcademicInstanceID='+AcademicInstanceID+'&ResultQueryCode='+ResultQueryCode+'';
    return this.dataService.getAll<passingcertificate[]>()
  }

  public GetClassIDByStudentID(StudentID,ExamInstanceID,CoursePartID ,BranchID) {
    this.dataService.setControllerName = '/PortalStudentMigrationApplication/';
    this.dataService.setMethodName = 'GetClassIDByStudentID?StudentID='+StudentID+'&ExamInstanceID='+ExamInstanceID+'&CoursePartID='+CoursePartID+'&BranchID='+BranchID; // setting method name from API controller.
    return this.dataService.getAll<passingcertificate[]>()
  }

  public GetDocumentPathForPassingCertificate(ApplicationNO,ExamInstanceID) {
    this.dataService.setControllerName = '/PortalStudentPassingCertificateApplication/';
    this.dataService.setMethodName = 'GetDocumentPathForPassingCertificate?ApplicationNO='+ApplicationNO+'&ExamInstanceID='+ExamInstanceID; // setting method name from API controller.
    return this.dataService.getAll<passingcertificate[]>()
  }
}
